<template>
  <!-- 购买数据服务 -->
  <div class="device-buy-service">
    <h1 class="item-title">{{ $t('components_device_buy_service.he_tong_xin_xi') }}</h1>
    <div class="item-title-info">
      <el-row>
        <el-col :span="8">
          <span class="label">{{ $t('components_device_buy_service.he_tong_bian_hao') }}：</span>
          <span class="value">{{ detail.contractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_device_buy_service.sghth') }}：</span>
          <span class="value">{{ detail.customContractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_device_buy_service.dai_li_gong_si') }}：</span>
          <span class="value">{{ detail.partyAName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_device_buy_service.yi_fang') }}：</span>
          <span class="value">{{ detail.customerName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_device_buy_service.shou_hou_gong_si') }}：</span>
          <span class="value">{{ detail.afterServiceName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_device_buy_service.xiang_mu_ming_cheng') }}：</span>
          <span class="value">{{ detail.locationName }}</span>
        </el-col>
        <el-col :span="18">
          <span class="label">{{ $t('components_device_buy_service.shi_yong_di_dian') }}：</span>
          <span class="value">{{ detail.useLocation }}</span>
        </el-col>
      </el-row>
    </div>
    <h1 class="item-title">{{ $t('components_device_buy_service.she_bei_xin_xi') }}</h1>
    <div style="margin-bottom: 30px">
      <custom-table index tableCode="buySimService" :data="dataList" @filter="filterChange" @sort="sortChange"
        :slots="['serviceScheme', 'bookingNum', 'totalAmount']">
        <template slot="serviceScheme" slot-scope="scope">
          <custom-select url="simDataSelect" v-model="scope.row.goodsSkuId" :model="scope.row"
            :disabled="model.type === 'watch'" :props="{
              label: 'goodsName',
              value: 'goodsSkuId',
              map: { currencyUnit: 'currencyUnit', goodsCode: 'goodsCode', goodsName: 'goodsName', unit: 'unit', unitPrice: 'unitPrice', specNames: 'specNames' },
            }" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
        </template>
        <template slot="bookingNum" slot-scope="scope">
          <el-input v-model="scope.row.bookingNum" style="width: 80px" :disabled="model.type === 'watch'"></el-input>
        </template>
        <template slot="totalAmount" slot-scope="scope">
          <span>{{ Number.parseInt(scope.row.bookingNum || 0, 10) * Number.parseInt(scope.row.unitPrice || 0, 10)
          }}</span>
        </template>
      </custom-table>
    </div>
    <el-form :model="form" ref="form" label-width="auto">
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('components_device_buy_service.shen_qing_miao_shu')" prop="applyDesc" :rules="rules">
            <el-input :disabled="model.type === 'watch'" type="textarea" :rows="4" placeholder="" v-model="form.applyDesc"
              style="width: 636px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '', // 新增时为orderId, 编辑查看时为changeId
        };
      },
    },
  },
  data() {
    return {
      detail: {},
      dataList: [],
      form: {
        orderId: '',
        detailList: [],
        applyDesc: '',
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        applyDesc: [
          { required: true, message: this.$t('components_device_buy_service.qtxsqms') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.getApplyInfo();
      }
      if (this.model.type === 'edit') {
        this.getChangeDetail();
      }
      if (this.model.type === 'watch') {
        this.getChangeDetail();
      }
    },
    // 申请信息
    getApplyInfo: function () {
      if (this.model.row.item) {
        this.detail = this.model.row.item;
        const row = { ...this.model.row.item, goodsSkuId: '', bookingNum: '', };
        this.dataList = [row];
      } else {
        this.$getJSON(apis.simDataDeviceSelect, {
          orderId: this.model.row.orderId,
          deviceIdList: this.model.row.deviceIdList,
        }).then((res) => {
          this.detail = res.data;
          this.dataList = res.data.deviceList;
        });
      }

    },
    // 获取详情
    getChangeDetail: function () {
      this.$getJSON(apis.simDataBuyApplyInfo, {
        applyId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
        this.dataList = res.data.deviceList;
        this.form.orderId = res.data.orderId;
        this.form.applyDesc = res.data.applyDesc;
      });
    },
    // 确认保存
    onConfirm: function () {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        const hasEmpty = this.dataList.find(t => !t.goodsSkuId);
        if (hasEmpty) {
          this.$message.error(this.$t('components_device_buy_service.qxzsjfwfa'));
          return;
        }
        this.form.orderId = this.model.row.orderId;
        this.form.detailList = this.dataList;
        const reqData = { ...this.form };
        reqData.contractNo = this.detail.contractNo;

        const reqUrl = this.model.row.item ? apis.simDataApplyForEus : apis.simDataBuyApply;
        this.$postJSON(reqUrl, reqData).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
        });
      });
    },
  },
};
</script>

<style lang="scss">
.device-buy-service {
  .el-form-item--small .el-form-item__label {
    line-height: 32px;
  }
}
</style>
